<template>
  <v-container fluid class="py-4 px-2 px-md-6">
    <v-card class="pa-6 global-dashboard-card">
      <v-card-title class="text-h6 font-weight-bold">📊 Dashboards TI</v-card-title>
      <v-divider class="mb-4" />

      <v-row>
        <v-col cols="12" md="6">
          <v-card class="mb-4 white-card">
            <v-card-title class="dashboard-header">👥 Colaboradores</v-card-title>
            <v-card-text>
              <pie-chart :data="datosColaboradores" />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="mb-4 white-card">
            <v-card-title class="dashboard-header">💻 Equipos</v-card-title>
            <v-card-text>
              <pie-chart :data="datosEquipos" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-for="card in tarjetasPerifericos"
          :key="card.tipo"
          cols="12"
          sm="6"
          md="4"
        >
          <v-card class="mb-4 white-card">
            <v-card-title class="dashboard-header">{{ card.icon }} {{ card.titulo }}</v-card-title>
            <v-card-text>
              <pie-chart :data="card.datos" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="justify-end mt-4">
        <v-col cols="auto">
          <v-btn color="grey darken-3" @click="$router.push('/inicio')">
            <v-icon left>mdi-home</v-icon> Volver a Inicio
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import API_BASE from "@/helpers/api";
import PieChart from "@/components/PieChart.vue";

/** Orden y etiquetas de gráficos por tipo (debe coincidir con `tipo` en API / inventario). */
const TIPOS_PERIFERICOS_DASHBOARD = [
  { tipo: "Monitor", titulo: "Monitores", icon: "🖥" },
  { tipo: "Mouse", titulo: "Mouse", icon: "🖱" },
  { tipo: "Teclado", titulo: "Teclados", icon: "⌨" },
  { tipo: "USB HUB", titulo: "USB Hub", icon: "🔌" },
  { tipo: "Auriculares", titulo: "Auriculares", icon: "🎧" },
];

export default {
  name: "DashboardsTIView",
  components: { PieChart },
  data() {
    return {
      usuario: JSON.parse(sessionStorage.getItem("usuario") || "null"),
      datosColaboradores: [],
      tarjetasPerifericos: [],
      datosEquipos: [],
    };
  },
  async mounted() {
    await this.obtenerDatosTI();
  },
  methods: {
    async obtenerDatosTI() {
      try {
        const res = await axios.get(`${API_BASE}/dashboard/resumen-ti`, {
          headers: { "x-user-role": this.usuario ? this.usuario.rol : "" },
        });

        this.datosColaboradores = [
          { label: "Activo", valor: parseInt((res.data.colaboradores.find(c => (c.status || "").toLowerCase() === "activo") || {}).count || 0, 10) },
          { label: "Inactivo", valor: parseInt((res.data.colaboradores.find(c => (c.status || "").toLowerCase() === "inactivo") || {}).count || 0, 10) },
        ];

        const piePerif = (p) => [
          { label: "Disponible", valor: Number(p?.disponible) || 0 },
          { label: "Asignado", valor: Number(p?.asignado) || 0 },
        ];
        const porTipo = res.data.perifericosPorTipo || [];
        const pick = (nombre) => piePerif(porTipo.find((x) => x.tipo === nombre));
        this.tarjetasPerifericos = TIPOS_PERIFERICOS_DASHBOARD.map(({ tipo, titulo, icon }) => ({
          tipo,
          titulo,
          icon,
          datos: pick(tipo),
        }));

        const eq = res.data.equipos || [];
        const n = (estado) =>
          parseInt((eq.find((e) => e.estado === estado) || {}).count ?? 0, 10) || 0;
        this.datosEquipos = [
          { label: "Activo", valor: n("Activo") },
          { label: "Disponible", valor: n("Disponible") },
          { label: "Inactivo", valor: n("Inactivo") },
        ];
      } catch (err) {
        console.error("Error al obtener resumen TI:", err);
      }
    },
  },
};
</script>

<style scoped>
.white-card {
  background: rgba(255, 255, 255, 0.55);
  color: #333;
}

.theme--dark .white-card {
  background: rgba(30, 30, 35, 0.98);
  color: #e0e0e0;
}

.global-dashboard-card {
  background: rgba(0, 0, 0, 0.08);
}
.theme--light .global-dashboard-card {
  background: rgba(255, 255, 255, 0.843);
}
.theme--dark .global-dashboard-card {
  background: rgba(0, 0, 0, 0.732);
}
</style>
